import dayjs from 'dayjs'
import { type DateRange } from 'react-day-picker'
import { HighlightType } from '@node-space/ui-components'
import { CardTransaction, CardTransactionStatus } from 'services/CardService'
import { formatLuceneDate, joinLuceneQuery, luceneField } from 'utils/lucene'

export const formatCurrency = (amount: number, currency: string) => {
  const formattedAmount = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `${formattedAmount} ${currency.toUpperCase()}`
}

export const getStatusType = (status: CardTransactionStatus): HighlightType => {
  switch (status) {
    case 'SETTLED':
      return HighlightType.Success
    case 'DECLINED':
    case 'CANCELLED':
      return HighlightType.Error
    case 'AUTHORIZED':
      return HighlightType.Neutral
    case 'PENDING':
      return HighlightType.Warning
    default:
      return HighlightType.Neutral
  }
}

export const getStatusTranslationKey = (status: CardTransactionStatus): string => {
  switch (status) {
    case 'SETTLED':
      return 'customers.cardTransactionsTable.statusSettled'
    case 'DECLINED':
      return 'customers.cardTransactionsTable.statusDeclined'
    case 'CANCELLED':
      return 'customers.cardTransactionsTable.statusCancelled'
    case 'AUTHORIZED':
      return 'customers.cardTransactionsTable.statusAuthorized'
    case 'PENDING':
      return 'customers.cardTransactionsTable.statusPending'
    default:
      return status
  }
}

export const buildTransactionsQuery = (
  searchTerm: string,
  dateRange: DateRange,
  customerId: string
): string | undefined =>
  joinLuceneQuery(
    [
      dateRange?.from &&
        luceneField('fromTimestamp', formatLuceneDate(dayjs(dateRange.from).startOf('day'))),
      dateRange?.to &&
        luceneField('toTimestamp', formatLuceneDate(dayjs(dateRange.to).endOf('day'))),
      searchTerm && luceneField('transactionId', searchTerm),
      luceneField('customerId', customerId),
    ],
    ' '
  )

export const getUsdAmount = (transaction: CardTransaction): string => {
  if (transaction.metadata?.usdAmount) {
    return formatCurrency(transaction.metadata.usdAmount, 'USD')
  }

  if (transaction.asset === 'USD') {
    return formatCurrency(transaction.settledAmount || transaction.authorizedAmount, 'USD')
  }

  return '-'
}
